export const EDIT_PROJECT_NAME = "edit_project";
export const EDIT_PROJECT_DESC = `Edits an existing project via GraphQL mutation.

Use when the user asks to rename a project, change color, or update description.

Input:
- 'projectId' (required): Target Project ID to update.
- 'name' (optional): New project name.
- 'color' (optional): New hex color '#RRGGBB'.
- 'description' (optional): New description.
- 'organizationId' (optional): Used only to build 'projectPath' in the result.

Notes:
- At least one of 'name', 'color', or 'description' must be provided.
- Returns the updated project's basic fields and convenience links.`;
